<template>
  <div id="productDetail">
    <NavigationBar />
    <!-- DESKTOP -->
    <div class="uk-visible@s uk-section uk-container" id="topBanner">
      <div class="">
        <p class="uk-text-large" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: false;">ELECTRONIC TV</p>
      </div>
      <div class="">
        <div class="uk-grid-collapse uk-child-width-1-2 uk-grid" uk-grid>
          <!-- Filter By Dropdown -->
          <div>
            <div class="uk-inline uk-width-1-1">
              <button style="padding-left: 15px; padding-right: 10px;" class="uk-button uk-button-default uk-width-1-1 uk-flex uk-flex-between uk-flex-middle" type="button" uk-toggle="target: #filter-dropdown">
                FILTER BY <span uk-icon="icon: chevron-down"></span>
              </button>
              <div id="filter-dropdown" uk-dropdown="mode: click; pos: bottom-justify">
                <ul class="uk-nav uk-dropdown-nav">
                  <li v-for="option in category" :key="option.name">
                    <label>
                      <input
                        class="uk-checkbox"
                        type="checkbox"
                        :value="option.seo_url"
                        v-model="selectedCategories"
                      />
                      {{ option.name }}
                    </label>
                  </li>
                  <li class="uk-nav-divider"></li>
                  <li>
                    <button class="uk-button uk-button-primary uk-width-1-1" @click="applyFilters()">Apply Filters</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Sort By Dropdown -->
          <div>
            <div class="uk-inline uk-width-1-1">
              <button style="padding-left: 15px; padding-right: 10px;" class="uk-button uk-button-default uk-width-1-1 uk-flex uk-flex-between uk-flex-middle" type="button" uk-toggle="target: #sort-dropdown">
                SORT BY <span uk-icon="icon: chevron-down"></span>
              </button>
              <div id="sort-dropdown" uk-dropdown="mode: click; pos: bottom-justify">
                <ul class="uk-nav uk-dropdown-nav">
                  <li v-for="option in sortOptions" :key="option.value">
                    <a href="#" @click.prevent="applySorting(option.value, option.label)">
                      {{ option.label }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="uk-grid uk-grid-small uk-margin-top" uk-grid uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">
        <div class="uk-width-1-2 uk-width-1-4@s" v-for="(product, index) in products" v-bind:key="index">
          <div @click="openProduct(product.seo_url, product.category.name)" class="cursor uk-card uk-box-shadow-hover-xlarge uk-card-default" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: false;">
            <div class="uk-card-media-top">
              <img :src="product.thumbnail" :alt="product.name">
               <!-- <img src="../../assets/images/products/echo.jpg" /> -->
            </div>
            <div class="uk-card-body uk-padding-remove">
              <div class="uk-padding-small">
                <p class="uk-margin-remove uk-text-small uk-text-muted uk-text-capitalize">{{ product.category.name }}</p>
                <p class="uk-text-uppercase uk-text-small uk-margin-remove">{{ product.name }}</p>
                <p class="uk-text-warning uk-text-small uk-margin-remove uk-text-bold">{{ formatRupiah(product.price) }}</p>
                <div v-if="product.discounted_price > 0" class="bold-cross-out">
                  <p class="uk-text-muted uk-text-small uk-margin-remove">{{ formatRupiah(product.discounted_price) }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- <img class="uk-width-1-1" :src="product.image" alt="TV Image"> -->
        </div>
      </div>
      <div v-else class="uk-section" style="height: 70vh">
      <div class="uk-container" style="height: 100%">
        <div
          class="uk-flex uk-flex-center uk-flex-middle"
          style="height: 100%"
        >
          <div uk-spinner></div>
        </div>
      </div>
    </div>
    </div>

    <!-- MOBILE -->
    <div class="uk-hidden@s">
      <div class="uk-padding-small">
        <p class="uk-text-large uk-margin-remove" uk-scrollspy="cls: uk-animation-slide-top; delay: 500; repeat: false;">ALL PRODUCT</p>
      </div>
      <div class="">
        <div class="uk-grid-collapse uk-child-width-1-2 uk-grid" uk-grid>
          <!-- Filter By Dropdown -->
          <div>
            <div class="uk-inline uk-width-1-1">
              <button style="padding-left: 15px; padding-right: 10px;" class="uk-button uk-button-default uk-width-1-1 uk-flex uk-flex-between uk-flex-middle" type="button" uk-toggle="target: #filter-dropdown">
                FILTER BY <span uk-icon="icon: chevron-down"></span>
              </button>
              <div id="filter-dropdown" uk-dropdown="mode: click; pos: bottom-justify">
                <ul class="uk-nav uk-dropdown-nav">
                  <li v-for="option in category" :key="option.name">
                    <label>
                      <input
                        class="uk-checkbox"
                        type="checkbox"
                        :value="option.seo_url"
                        v-model="selectedCategories"
                      />
                      {{ option.name }}
                    </label>
                  </li>
                  <li class="uk-nav-divider"></li>
                  <li>
                    <button class="uk-button uk-button-primary uk-width-1-1" @click="applyFilters()">Apply Filters</button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- Sort By Dropdown -->
          <div>
            <div class="uk-inline uk-width-1-1">
              <button style="padding-left: 15px; padding-right: 10px;" class="uk-button uk-button-default uk-width-1-1 uk-flex uk-flex-between uk-flex-middle" type="button" uk-toggle="target: #sort-dropdown">
                SORT BY <span uk-icon="icon: chevron-down"></span>
              </button>
              <div id="sort-dropdown" uk-dropdown="mode: click; pos: bottom-justify">
                <ul class="uk-nav uk-dropdown-nav">
                  <li v-for="option in sortOptions" :key="option.value">
                    <a href="#" @click.prevent="applySorting(option.value, option.label)">
                      {{ option.label }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="uk-grid uk-grid-small uk-padding-small" uk-grid uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: true;">
        <div class="uk-width-1-2 uk-width-1-4@s" v-for="(product, index) in products" v-bind:key="index">
          <div @click="openProduct(product.seo_url, product.category.name)" class="cursor uk-card uk-box-shadow-hover-xlarge uk-card-default" uk-scrollspy="cls: uk-animation-scale-up; delay: 500; repeat: false;">
            <div class="uk-card-media-top">
              <img :src="product.thumbnail" :alt="product.name">
               <!-- <img src="../../assets/images/products/echo.jpg" /> -->
            </div>
            <div class="uk-card-body uk-padding-remove">
              <div class="uk-padding-small">
                <p class="uk-margin-remove uk-text-small uk-text-muted uk-text-capitalize">{{ product.category.name }}</p>
                <p class="uk-text-uppercase uk-text-small uk-margin-remove">{{ product.name }}</p>
                <p class="uk-text-warning uk-text-small uk-margin-remove uk-text-bold">{{ formatRupiah(product.price) }}</p>
                <div v-if="product.discounted_price > 0" class="bold-cross-out">
                  <p class="uk-text-muted uk-text-small uk-margin-remove">{{ formatRupiah(product.discounted_price) }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- <img class="uk-width-1-1" :src="product.image" alt="TV Image"> -->
        </div>
      </div>
      <div v-else class="uk-section" style="height: 70vh">
      <div class="uk-container" style="height: 100%">
        <div
          class="uk-flex uk-flex-center uk-flex-middle"
          style="height: 100%"
        >
          <div uk-spinner></div>
        </div>
      </div>
    </div>
    </div>
    <h1 class="uk-heading-divider"></h1>
    <Footer />
  </div>
</template>
  
<script>
import NavigationBar from "@/components/NavigationBar.vue";
import Footer from "@/components/Footer.vue";
import NavbarMobileComponent from "@/components/NavbarMobileComponent.vue";
import VueCompareImage from "vue-compare-image";
import axios from "axios";
import { mapGetters } from "vuex";
import UIkit from "uikit";


export default {
  name: "productView",
  components: {
    NavigationBar,
    Footer,
    // eslint-disable-next-line vue/no-unused-components
    NavbarMobileComponent,
    // eslint-disable-next-line vue/no-unused-components
    VueCompareImage,
  },
  data() {
    return {
      data: {},
      banner: require('../../assets/woman-in-white-blazer-holding-tablet-computer-789822EDIT.jpg'),
      loading: false,
      category: [],
      selectedCategories: [], // Now an array for multiple selection
      sortOptions: [
        { label: "Name A-Z", value: "name_asc" },
        { label: "Name Z-A", value: "name_desc" },
        { label: "Price: Low to High", value: "price_asc" },
        { label: "Price: High to Low", value: "price_desc" },
      ],
      selectedSort: "",
      products: [],
    };
  },
  computed: {
    ...mapGetters("auth", ["IS_AUTH", "GET_USER"]),
    isSmall() {
      return window.innerWidth < 960;
    },
    isVerySmall() {
      return window.innerWidth < 640;
    },
  },
  watch: {
    // call again the method if the route changes
    // $route: "getProduct",
    // '$route.params.id': {
    //   immediate: true,
    //   handler(newVal) {
    //     this.category = this.replaceDashWithSpace(newVal);
    //     // this.loadProduct();
    //     this.getProduct();
    //   }
    // }
  },
  mounted() {
    // this.category = this.$route.params.id
    // this.category = this.replaceDashWithSpace(this.category)
    // // this.loadProduct();
    this.getProduct();
    this.getCategory();
  },
  methods: {
    replaceDashWithSpace(str) {
      return str.replace(/-/g, ' ');
    },
    async applyFilters() {
      const dropdown = UIkit.dropdown("#filter-dropdown");
      dropdown.hide();
      this.getProduct()
    },
    applySorting(value, label) {
      this.selectedSort = value;
      this.selectedSortLabel = label;

      // Close dropdown after selection
      const dropdown = UIkit.dropdown("#sort-dropdown");
      dropdown.hide();
      this.getProduct()
    },
    async getProduct() {
      this.loading = true;
      let queryParams = {};

      // Apply multiple categories filter (convert to a comma-separated string)
      if (this.selectedCategories.length > 0) {
        queryParams.category = this.selectedCategories.join(",");
      }

      // Apply sorting
      if (this.selectedSort === "name_asc") {
        queryParams.sort_by = "name";
        queryParams.order = "asc";
      } else if (this.selectedSort === "name_desc") {
        queryParams.sort_by = "name";
        queryParams.order = "desc";
      } else if (this.selectedSort === "price_asc") {
        queryParams.sort_by = "price";
        queryParams.order = "asc";
      } else if (this.selectedSort === "price_desc") {
        queryParams.sort_by = "price";
        queryParams.order = "desc";
      }
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}product/all`, {
            params: queryParams
          }
        )
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            this.products = data.data;
            this.setSeo();
            this.loading = false;
          } else {
            this.$router.push("/not-found");
          }
        })
        .catch((err) => {
          console.log(err)
          this.$router.push("/not-found");
        });
    },
    async getCategory() {
      axios
        .get(
          `${process.env.VUE_APP_API_ROOMI_URL}product/categories`
        )
        .then((res) => {
          if (res.status == 200) {
            const data = res.data;
            this.category = data.data;
          } 
        })
        .catch((err) => {
          console.log(err)
        });
    },
    setSeo() {
      let titlePage = "Product Roomi";
      const siteDescription = this.data.description;
      document.title = titlePage;
      const check_meta = document.querySelectorAll("meta");
      let count_check = 0;
      check_meta.forEach((check) => {
        if (
          check.getAttribute("name") == "description" ||
          check.getAttribute("name") == "title" ||
          check.getAttribute("name") == "robots"
        ) {
          if (check.getAttribute("name") == "description") {
            check.setAttribute("content", "");
          }
          if (check.getAttribute("name") == "title") {
            check.setAttribute("content", titlePage);
          }
          if (check.getAttribute("name") == "robots") {
            check.setAttribute("content", "index, follow");
          }
          count_check = 1;
        }
      });
      if (count_check == 0) {
        var meta_description = document.createElement("meta");
        meta_description.setAttribute("name", "description");
        meta_description.setAttribute("content", siteDescription);
        document.getElementsByTagName("head")[0].appendChild(meta_description);
        const meta_title = document.createElement("meta");
        meta_title.setAttribute("name", "title");
        meta_title.setAttribute("content", titlePage);
        document.getElementsByTagName("head")[0].appendChild(meta_title);
        const meta_robots = document.createElement("meta");
        meta_robots.setAttribute("name", "robots");
        meta_robots.setAttribute("content", "index, follow");
        document.getElementsByTagName("head")[0].appendChild(meta_robots);
      }
    },
    loadProduct(){
      if(this.category === 'smart camera'){
        this.products = [
          {
            name: 'SPYE',
            image: encodeURI('https://api.roomi.co.id/images/cctv SPYE.png')
          },
          {
            name: 'SPYE NIGHT',
            image: encodeURI('https://api.roomi.co.id/images/RM-I55B4S.png')
          },
          {
            name: 'SPYE NIGHT MOTION',
            image: encodeURI('https://api.roomi.co.id/images/RM-I65B4S-4CWT.png')
          },
          {
            name: 'SPYE MINI I',
            image: encodeURI('https://api.roomi.co.id/images/spye mini 1.png')
          },
          {
            name: 'SPYE MINI II',
            image: encodeURI('https://api.roomi.co.id/images/spye mini 2.png')
          }
        ]
      } else if (this.category === 'smart tv'){
        this.products = [
          {
            name: 'ROOMI T2 Digital TV',
            image: require('../../assets/images/products/roomi tv 32_ led tv.jpg')
            // image: encodeURI('https://api.roomi.co.id/images/smart-tv-led-1.jpeg')
          },
          {
            name: 'Smart Frameless Android TV',
            image: require('../../assets/images/products/roomi tv 32_frameless.jpg')
          },
          {
            name: 'Smart TV WEB-OS 2.0',
            image: require('../../assets/images/products/web os 55.jpg')
          },
          {
            name: 'GOOGLE TV',
            image: require('../../assets/images/products/google tv 86.jpg')
          },
        ]
      } else if (this.category === 'speaker'){
        this.products = [
          {
            name: 'Soundwave',
            image: require('../../assets/images/products/soundwave.jpg')
          },
          {
            name: 'Rave BOX',
            image: require('../../assets/images/products/rave box max.jpg')
          },
          {
            name: 'Wakanda Series',
            image: encodeURI('https://api.roomi.co.id/images/roomi 8.png')
          },
          {
            name: 'ROOMI PRO Series',
            image: require('../../assets/images/products/pro 10.jpg')
          },
          {
            name: 'Sonic Portable',
            image: require('../../assets/images/products/sonic.jpg')
          },
          {
            name: 'Echo Series',
            image: require('../../assets/images/products/echo.jpg')
          },
          {
            name: 'Grande',
            image: require('../../assets/images/products/grande.jpg')
          },
          {
            name: 'Velvet',
            image: require('../../assets/images/products/velvet.jpg')
          },
        ]
      } else if (this.category === 'ott box'){
        this.products = [
          {
            name: 'ROOMI OTT BOX',
            image: require('../../assets/images/products/ott box 2 gb+16gb.jpg')
          },
        ]
      } else if (this.category === 'smart led'){
        this.products = [
          {
            name: 'LUMIO',
            image: encodeURI('https://api.roomi.co.id/images/ROOMI SMART BULB 9W - NEW.png')
          },
        ]
      }
      this.loading = false
    },
    openProduct(product, category){
            // this.$router.push({ path: `/product/${product}` });
      this.$router.push({ name: 'product-detail', params: { categoryid: this.replaceSpaceWithDash(category), productid: this.replaceSpaceWithDash(product) } })
        },
    replaceSpaceWithDash(str) {
      return str.replace(/\s+/g, "-").toLowerCase();
    },
    formatRupiah(value) {
      if(value > 0){
        return `Rp ${value.toLocaleString('id-ID')}`;
      } else {
        return 'Rp 0';
      }
    },
  },
};
</script>

<style lang="less" scoped>
  .bold-cross-out {
      position: relative;
      display: inline-block;
      font-size: 18px;
  }

  .bold-cross-out::before {
      content: "";
      position: absolute;
      left: 0;
      top: 46%;
      width: 100%;
      height: 1px; /* Make the line thicker */
      background-color: rgb(150, 150, 150); /* Line color */
      // transform: rotate(-10deg);
  }
</style>